import { render, staticRenderFns } from "./open-link.vue?vue&type=template&id=01f305c8&scoped=true&"
import script from "./open-link.vue?vue&type=script&lang=js&"
export * from "./open-link.vue?vue&type=script&lang=js&"
import style0 from "./open-link.vue?vue&type=style&index=0&id=01f305c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f305c8",
  null
  
)

export default component.exports